import React, { useEffect, useState, useContext } from "react";
import { Grid } from "@mui/material";
import Table from "@mui/material/Table";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableContainer from "@mui/material/TableContainer";
import TableBody from "@mui/material/TableBody";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Collapse from "@mui/material/Collapse";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import TablePagination from "@mui/material/TablePagination";
import DownloadIcon from "@mui/icons-material/Download";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import UiDropZoneUploader from "../../../../../_uiComponents/common/form/UiDropZoneUploader";
import UiDropdownButton from "../../../../../_uiComponents/common/form/UiDropdownButton";
import { UploadStatus } from "../../../../../_uiComponents/common/DataGridComponents";
import UiCheckbox from "../../../../../_uiComponents/common/form/UiCheckBox";
import UiTableHead from "../../../../../_uiComponents/common/table/UiTableHead";
import UiSelects from "../../../../../_uiComponents/common/form/UiSelects";
import { useDispatch } from "react-redux";
import {
     dataFileTypeListRequest,
     dataUploadDataProcessingRecodeRequest,
     dataUploadDataTemplateListRequest,
     dataUploadDownloadSummaryRequest,
     dataUploadListRequest,
     dataUploadSilentListRequest,
     dataUploadSummeryRequest,
     dataFileSchemaRequest,
     dataUploadRecordCountRequest,
     downloadSchemaTempRequest,
     downloadActiveRecordsRequest,
     downloadDeletedRecordsRequest,
     dataUploadListRefreshRealTime,
} from "../../../../../../_redux/_actions";
import { useSelector } from "react-redux";
import moment from "moment/moment";
import { dataUploadTableConfig } from "./module.config";
// import JsonViewDataTable from "./JsonViewDataTable";
import UiCopyField from "../../../../../_uiComponents/common/form/UiCopyField";
import { Context } from "../../../../../../_context/Store";
import {
     contextApiActions,
     signalrTopics,
} from "../../../../../../_redux/_constants";
import { TimeInterval } from "rxjs/internal/operators/timeInterval";
import Reports from "../../../../reports/Reports";
import UiInput from "../../../../../_uiComponents/telerikComponents/UiInput";

function descendingComparator(a, b, orderBy) {
     if (b[orderBy] < a[orderBy]) {
          return -1;
     }
     if (b[orderBy] > a[orderBy]) {
          return 1;
     }
     return 0;
}

function getComparator(order, orderBy) {
     return order === "desc"
          ? (a, b) => descendingComparator(a, b, orderBy)
          : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
     const stabilizedThis = array.map((el, index) => [el, index]);
     stabilizedThis.sort((a, b) => {
          const order = comparator(a[0], b[0]);
          if (order !== 0) {
               return order;
          }
          return a[1] - b[1];
     });
     return stabilizedThis.map((el) => el[0]);
}

function TabPanel(props) {
     const { children, tabValue, index, ...other } = props;

     return (
          <div
               role="tabpanel"
               hidden={tabValue !== index}
               id={`full-width-tabpanel-${index}`}
               aria-labelledby={`full-width-tab-${index}`}
               {...other}
          >
               {tabValue === index && <Box sx={{ p: 3 }}>{children}</Box>}
          </div>
     );
}

export default function DataSection(props) {
     const [open, setOpen] = React.useState(false);
     const [value, setValue] = React.useState("success");
     const [page, setPage] = React.useState(1);
     const [rowsPerPage, setRowsPerPage] = React.useState(5);
     const [order, setOrder] = React.useState("asc");
     const [orderBy, setOrderBy] = React.useState();
     const [dataTableStatus, setDataTableStatus] = useState(null);
     const [currentCheck, setCurrentCheck] = useState(null);
     const [active, setActive] = React.useState();
     const [currentDataFileType, setCurrentDataFileType] = React.useState("");
     const [currentDataSchemaType, setCurrentDataSchemaType] =
          React.useState("");
     const [tabValue, setTabValue] = React.useState(0);
     const [status, setStatus] = useState(null);

     const [state, dispatch] = useContext(Context);

     const actionDispatch = useDispatch();

     useEffect(() => {
          if (state.signalRConnaction) {
               state.signalRConnaction.on(
                    signalrTopics.DATA_UPLOAD_STATUS_CHANGE,
                    (message) => {
                         console.log(message);
                         console.log("getting list status");
                         actionDispatch(
                              dataUploadListRefreshRealTime(
                                   JSON.parse(message),
                              ),
                         );
                    },
               );

               state.signalRConnaction.on(
                    signalrTopics.DATA_UPLOAD_RECORD_CHANGE,
                    (message) => {
                         console.log("getting list status 2");

                         actionDispatch(
                              dataUploadSilentListRequest({
                                   page: page,
                                   pageSize: rowsPerPage,
                              }),
                         );
                    },
               );
          }
          return () => {
               if (state.signalRConnaction) {
                    state.signalRConnaction.off(
                         signalrTopics.DATA_UPLOAD_STATUS_CHANGE,
                    );

                    state.signalRConnaction.off(
                         signalrTopics.DATA_UPLOAD_RECORD_CHANGE,
                    );
               }
          };
     }, [state.signalRConnaction]);

     const manageSummeyOpen = (clickedIndex, row) => {
          if (active === clickedIndex) {
               setActive(null);
               setOpen(true);
          } else {
               setActive(clickedIndex);
               setOpen(true);
               setDataTableStatus(row);
               actionDispatch(
                    dataUploadSummeryRequest({
                         id: row?.id ? row?.id : 1,
                         page: page,
                         pageSize: rowsPerPage,
                    }),
               );
          }
     };

     const handleChangePage = (event, newPage) => {
          setPage(newPage + 1);
     };

     const handleChangeRowsPerPage = (event) => {
          setRowsPerPage(event.target.value);
          setPage(1);
     };

     const pagePerSize = 0;
     const {
          dataUploadAdd,
          dataUploadList,
          dataUploadSummery,
          dataFileTypeList,
          dataFileSchemaList,
          RecordsCountData,
     } = useSelector((state) => {
          return {
               dataTemplate: state.dataUpload.dataTemplate.recordsList,
               dataUploadAdd: state.dataUpload.dataUploadAdd,
               dataUploadList: state.dataUpload.dataUploadList,
               dataUploadSummery: state.dataUpload.dataUploadSummery,
               dataFileTypeList: state.dataUpload.dataFileTypeList,
               dataFileSchemaList: state.dataUpload.dataFileSchemaList,
               RecordsCountData: state.dataUpload.RecordsCountData,
          };
     });

     useEffect(() => {
          actionDispatch(dataFileTypeListRequest());
          actionDispatch(
               dataUploadDataTemplateListRequest({
                    page: pagePerSize,
                    pageSize: rowsPerPage,
               }),
          );
     }, []);

     useEffect(() => {
          actionDispatch(
               dataUploadListRequest({
                    page: page,
                    pageSize: rowsPerPage,
               }),
          );
     }, [page, rowsPerPage]);

     useEffect(() => {
          actionDispatch(
               dataUploadListRequest({
                    page: page,
                    pageSize: rowsPerPage,
               }),
          );
     }, [dataUploadAdd?.isSuccess]);

     const [contains, setContains] = React.useState("");

     const handleFileTypeChange = (event) => {
          setCurrentDataFileType(event.target.value);
          setCurrentDataSchemaType("");
          actionDispatch(
               dataFileSchemaRequest({ dataFileTypeId: event.target.value }),
          );
     };

     const handleSchemaType = (event) => {
          setCurrentDataSchemaType(event.target.value);

          let payload = {
               fileType: currentDataFileType,
               schemaType: event.target.value,
          };

          actionDispatch(dataUploadRecordCountRequest(payload));
     };

     //Dropdown Button
     const dropdownOptions = ["All", "Success", "Fail"];
     const handleBtnClickFunc = (id, statusId) => {
          actionDispatch(
               dataUploadDownloadSummaryRequest({
                    processId: id,
                    summaryStatusId: statusId,
               }),
          );
     };

     const menuItemClick = (id, statusId) => {
          actionDispatch(
               dataUploadDownloadSummaryRequest({
                    processId: id,
                    summaryStatusId: statusId,
               }),
          );
     };

     //Sorting
     const handleRequestSort = (event, property) => {
          const isAsc = orderBy === property && order === "asc";
          setOrder(isAsc ? "desc" : "asc");
          setOrderBy(property);
     };

     const visibleRows = React.useMemo(
          () =>
               stableSort(
                    dataUploadList?.recordsList
                         ? dataUploadList?.recordsList
                         : [],
                    getComparator(order, orderBy),
               ),
          [
               order,
               orderBy,
               page,
               rowsPerPage,
               dataUploadList?.recordsList ? dataUploadList?.recordsList : [],
          ],
     );

     const handleChange = (event) => {
          const statusID =
               event.target.id === "totalCheckbox"
                    ? 1
                    : event.target.id === "successCheckbox"
                      ? 2
                      : 3;
          setStatus(statusID);
          setCurrentCheck(event.target.id);
          if (!event?.target?.checked) {
               setCurrentCheck(null);
               actionDispatch(
                    dataUploadSummeryRequest({
                         id: dataTableStatus?.id ? dataTableStatus?.id : 1,
                         page: page,
                         pageSize: rowsPerPage,
                    }),
               );
          } else {
               actionDispatch(
                    dataUploadDataProcessingRecodeRequest({
                         DataProcessingId: dataTableStatus?.id
                              ? dataTableStatus?.id
                              : 1,
                         statusId: statusID,
                         page: page,
                         pageSize: rowsPerPage,
                    }),
               );
          }
     };

     const tabHandleChange = (event, newValue) => {
          setTabValue(newValue);
          console.log(newValue);
     };

     const downloadSchemaTemplate = () => {
          let payload = {
               fileType: currentDataFileType,
               schemaType: currentDataSchemaType,
          };

          actionDispatch(downloadSchemaTempRequest(payload));
     };

     const downloadActiveRecords = () => {
          let payload = {
               fileType: currentDataFileType,
               schemaType: currentDataSchemaType,
          };

          actionDispatch(downloadActiveRecordsRequest(payload));
     };

     const downloadDeletedRecords = () => {
          let payload = {
               fileType: currentDataFileType,
               schemaType: currentDataSchemaType,
          };

          actionDispatch(downloadDeletedRecordsRequest(payload));
     };

     return (
          <>
               <div className="sba-tab-container">
                    <Tabs
                         onChange={tabHandleChange}
                         value={tabValue}
                         selectionFollowsFocus
                    >
                         <Tab label="Generate Game Code"></Tab>
                         <Tab label="Reports"></Tab>
                    </Tabs>

                    <TabPanel
                         tabValue={tabValue}
                         index={0}
                         className="sba-tab-panel"
                    >
                         <Grid container spacing={2} sx={{ mt: 2, mb: 2 }}>
                              <Grid item xs={12} lg={6}>
                                   <div className="sa-text-input-wr">
                                        <span>
                                             Generate 1 game code for every{" "}
                                        </span>{" "}
                                        <UiInput />
                                        <span>Sales</span>
                                   </div>

                                   <UiDropZoneUploader
                                        disable={!currentDataSchemaType}
                                        fileType={currentDataFileType}
                                        schemaType={currentDataSchemaType}
                                        actionTypeId={1}
                                   />
                              </Grid>
                         </Grid>
                    </TabPanel>
                    <TabPanel
                         tabValue={tabValue}
                         index={1}
                         className="sba-tab-panel"
                    >
                         <Grid container spacing={2} sx={{ mt: 1, mb: 2 }}>
                              <Grid item xs={12} lg={12}>
                                   <Reports />
                              </Grid>
                         </Grid>
                    </TabPanel>
               </div>

               {/* {dataUploadAdd?.isSuccess && */}
               <div className="sba-table-main-wr">
                    <div className="sba-data-upload-summary-sub-heading">
                         <h5>Data Upload Summary</h5>
                    </div>
                    <TableContainer component={Paper}>
                         <Table
                              sx={{ minWidth: 650, mt: 0 }}
                              aria-label="simple table"
                              className="sbt-data-grid"
                         >
                              <UiTableHead
                                   headings={
                                        dataUploadTableConfig.list.tableMapper
                                   }
                                   order={order}
                                   orderBy={orderBy}
                                   onRequestSort={handleRequestSort}
                                   isShow={true}
                              />
                              <TableBody>
                                   {visibleRows.map((row, index) => (
                                        <>
                                             <TableRow>
                                                  <TableCell>
                                                       {row?.dataFileType}
                                                  </TableCell>
                                                  <TableCell align="left">
                                                       {row?.schemaName
                                                            ? row?.schemaName
                                                            : ""}
                                                  </TableCell>
                                                  <TableCell align="center">
                                                       {row?.date}
                                                  </TableCell>
                                                  <TableCell align="left">
                                                       {row?.actionType}
                                                  </TableCell>
                                                  {/* <TableCell align="center">
                                            {row?.status}
                                        </TableCell> */}
                                                  <TableCell align="center">
                                                       <Stack
                                                            direction="row"
                                                            spacing={1}
                                                       >
                                                            <UploadStatus
                                                                 status={row.status.toUpperCase()}
                                                            />
                                                       </Stack>
                                                  </TableCell>
                                                  <TableCell align="center">
                                                       <Button
                                                            size="small"
                                                            variant="outlined"
                                                            endIcon={
                                                                 active ==
                                                                      index &&
                                                                 open ? (
                                                                      <KeyboardArrowUpIcon />
                                                                 ) : (
                                                                      <KeyboardArrowDownIcon />
                                                                 )
                                                            }
                                                            onClick={() => {
                                                                 manageSummeyOpen(
                                                                      index,
                                                                      row,
                                                                 );
                                                            }}
                                                       >
                                                            Summary
                                                       </Button>
                                                  </TableCell>
                                                  <TableCell align="right">
                                                       <UiDropdownButton
                                                            rowId={row?.id}
                                                            defaultBtnName="Download Summary"
                                                            dropdownOptions={
                                                                 dropdownOptions
                                                            }
                                                            handleBtnClick={() => {
                                                                 handleBtnClickFunc(
                                                                      row?.id,
                                                                      1,
                                                                 );
                                                            }}
                                                            menuItemClick={
                                                                 menuItemClick
                                                            }
                                                       />
                                                  </TableCell>
                                             </TableRow>

                                             <TableRow>
                                                  <TableCell
                                                       style={{
                                                            paddingBottom: 0,
                                                            paddingTop: 0,
                                                            background:
                                                                 "#f9f8f8",
                                                            border: "none",
                                                       }}
                                                       colSpan={12}
                                                  >
                                                       <Collapse
                                                            in={
                                                                 active ==
                                                                      index &&
                                                                 open
                                                            }
                                                            timeout="auto"
                                                            unmountOnExit
                                                       >
                                                            <Box
                                                                 sx={{
                                                                      margin: 1,
                                                                 }}
                                                            >
                                                                 <Grid
                                                                      container
                                                                      spacing={
                                                                           2
                                                                      }
                                                                      sx={{
                                                                           mt: 2,
                                                                           mb: 2,
                                                                      }}
                                                                 >
                                                                      <Grid
                                                                           item
                                                                           xs={
                                                                                12
                                                                           }
                                                                           lg="4"
                                                                           className="sbm-summary-table-box"
                                                                      >
                                                                           <UiCheckbox
                                                                                handleChange={
                                                                                     handleChange
                                                                                }
                                                                                id="totalCheckbox"
                                                                                checked={
                                                                                     currentCheck ===
                                                                                     "totalCheckbox"
                                                                                }
                                                                           />
                                                                           <label for="totalCheckbox">
                                                                                <div className="sbm-records-ui sbm-total-records">
                                                                                     <h3>
                                                                                          Total
                                                                                          Records
                                                                                     </h3>
                                                                                     <span>
                                                                                          {dataTableStatus?.totalRecords
                                                                                               ? dataTableStatus?.totalRecords
                                                                                               : 0}
                                                                                     </span>
                                                                                </div>
                                                                           </label>
                                                                      </Grid>
                                                                      <Grid
                                                                           item
                                                                           xs={
                                                                                12
                                                                           }
                                                                           lg="4"
                                                                           className="sbm-summary-table-box"
                                                                      >
                                                                           <UiCheckbox
                                                                                id="successCheckbox"
                                                                                handleChange={
                                                                                     handleChange
                                                                                }
                                                                                checked={
                                                                                     currentCheck ===
                                                                                     "successCheckbox"
                                                                                }
                                                                           />
                                                                           <label for="successCheckbox">
                                                                                <div className="sbm-records-ui sbm-success-records">
                                                                                     <h3>
                                                                                          Success
                                                                                          Records
                                                                                     </h3>
                                                                                     <span>
                                                                                          {dataTableStatus?.successRecords
                                                                                               ? dataTableStatus?.successRecords
                                                                                               : 0}
                                                                                     </span>
                                                                                </div>
                                                                           </label>
                                                                      </Grid>
                                                                      <Grid
                                                                           item
                                                                           xs={
                                                                                12
                                                                           }
                                                                           lg="4"
                                                                           className="sbm-summary-table-box"
                                                                      >
                                                                           <UiCheckbox
                                                                                id="failedCheckbox"
                                                                                handleChange={
                                                                                     handleChange
                                                                                }
                                                                                checked={
                                                                                     currentCheck ===
                                                                                     "failedCheckbox"
                                                                                }
                                                                           />
                                                                           <label for="failedCheckbox">
                                                                                <div className="sbm-records-ui sbm-failed-records">
                                                                                     <h3>
                                                                                          Failed
                                                                                          Records
                                                                                     </h3>
                                                                                     <span>
                                                                                          {dataTableStatus?.failedRecords
                                                                                               ? dataTableStatus?.failedRecords
                                                                                               : 0}
                                                                                     </span>
                                                                                </div>
                                                                           </label>
                                                                      </Grid>
                                                                 </Grid>

                                                                 {/* <JsonViewDataTable
                                                                      rowId={
                                                                           row?.id
                                                                      }
                                                                      currentCheck={
                                                                           currentCheck
                                                                      }
                                                                      dataTableStatus={
                                                                           dataTableStatus
                                                                      }
                                                                      status={
                                                                           status
                                                                      }
                                                                 /> */}
                                                            </Box>
                                                       </Collapse>
                                                  </TableCell>
                                             </TableRow>
                                        </>
                                   ))}
                              </TableBody>
                         </Table>
                    </TableContainer>
                    <TablePagination
                         rowsPerPageOptions={[5, 10, 15, 20, 25]}
                         component="div"
                         count={dataUploadList?.totalRecords}
                         rowsPerPage={rowsPerPage}
                         page={page - 1}
                         onPageChange={handleChangePage}
                         onRowsPerPageChange={handleChangeRowsPerPage}
                    />
               </div>
               {/* } */}
          </>
     );
}
